import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const SplitNotifications = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  sgwtWebAnalytics?.trackEvent(
    'Header',
    'user preferences, option tab, spli notifications',
    String(!userPreferences.splitNotifications),
  );

  const handleChange = (): void => {
    updateUserPreferences({ ...userPreferences, splitNotifications: !userPreferences.splitNotifications });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-2 px-4 border-bottom">
      <label htmlFor="split-notifications">
        <FormattedMessage id="userPreferences.label.splitNotifications" />
      </label>
      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="splitNotifications">
        <input
          id="split-notifications"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.splitNotifications}
          onChange={handleChange}
          data-e2e={'splitNotifications-checkbox'}
        />
        <span>
          <FormattedMessage id={`switchInput.${userPreferences.splitNotifications ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};

export default SplitNotifications;
